export default __webpack_public_path__ + "static/favicon-67094309a423ded6019e72089da931ed.ico";